import { Attribute } from '@emm/core/models/attribute.model';
import { createAction, props } from '@ngrx/store';

export enum AttributesAction {
    LoadAll = '[Menu Base Effects] Load All Attributes',
    LoadAllSuccess = '[Menu API] Load All Attributes Success',
    LoadAllFailure = '[Menu API] Load All Attributes Failure'
}

export const AttributesActions = {
    loadAll: createAction(AttributesAction.LoadAll),
    loadAllSuccess: createAction(AttributesAction.LoadAllSuccess, props<{ attributes: Attribute[] }>()),
    loadAllFailure: createAction(AttributesAction.LoadAllFailure, props<{ error: any }>())
};

export const AsyncActions = {
    loadActions: [AttributesActions.loadAll],
    successActions: [AttributesActions.loadAllSuccess],
    errorActions: [AttributesActions.loadAllFailure]
};
